import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';

const MusicLabelForm = ({ data, mode, onClose, onSubmit, open}) => {

  const [formData,setFormData] = useState({
    city_name: '',
    music_label_name: '',
    label_type_name: '',
    address: '',
    email: '',
    telephone: '',
    status_name: '',
    is_partner: false,
    percent:0
  })

  useEffect(() => {
    if (data) {
      const labelData = data.original || data;
      setFormData({
        city_name: labelData.city_name ?? '',
        music_label_name: labelData.music_label_name ?? '',
        label_type_name: labelData.label_type_name ?? '',
        address: labelData.address ?? '',
        email: labelData.email ?? '',
        telephone: labelData.telephone ?? '',
        status_name: labelData.status_name ?? '',
        is_partner: labelData.is_partner ?? false,
        percent: labelData.percentage ?? 0
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePartnerChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      is_partner: e.target.value === 'true',
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(formData);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const isReadOnly = mode === 'view';

  const StatusColor = (status) => {
    switch (status) {
      case 'WAITING':
        return 'bg-warning';
      case 'APPROVED':
      case 'ACTIVE':
        return 'bg-success';
      case 'PENDING':
        return 'bg-orange';
      case 'REJECTED':
        return 'bg-danger';
      case 'ON PROGRESS':
        return 'bg-primary';
      case 'TERMINATED':
        return 'bg-red';
      default:
        return 'bg-secondary';
    }
  };

  return (
    <div
        className={`modal fade ${open ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: open ? "block" : "none" }}
        aria-hidden={!open}
    >
        <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
                <div className="modal-header justify-content-between">
                    <h5 className="modal-title">{mode === 'create' ? 'Create Music Label' : 'View Music Label'}</h5>
                    <button type="button" className="close" onClick={handleClose}>
                        <Icon icon="mdi:close-circle" width={24} height={24} />
                    </button>
                </div>
                <div className="modal-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                    {[
                        { label: 'City', name: 'city_name' },
                        { label: 'Label Name', name: 'music_label_name' },
                        { label: 'Label Type', name: 'label_type_name' },
                        { label: 'Address', name: 'address' },
                        { label: 'Email', name: 'email' },
                        { label: 'Telephone', name: 'telephone' },
                    ].map(({ label, name }) => (
                        <div className="col-md-6 mb-3" key={name}>
                        <label className="col-form-label" htmlFor={name}>
                            {label}:
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id={name}
                            name={name}
                            value={formData[name] || ''}
                            onChange={handleChange}
                            readOnly={isReadOnly}
                        />
                        </div>
                    ))}
                    <div className="col-md-6 mb-3">
                        <label className="col-form-label" htmlFor="status_name">
                            Status:
                        </label>
                        <input
                            type="text"
                            className={`form-control status-input ${isReadOnly ? StatusColor(formData.status_name) : 'bg-secondary'}`}
                            id="status_name"
                            name="status_name"
                            value={formData.status_name}
                            onChange={handleChange}
                            readOnly={isReadOnly}
                        />
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="col-form-label" htmlFor="status_name">
                            Persentase:
                        </label>
                        <input
                            type="number"
                            className={`form-control`}
                            id="percent"
                            name="percent"
                            value={formData.percent}
                            onChange={handleChange}
                            readOnly={isReadOnly}
                        />
                    </div>
                        <div className="col-md-6 mb-3">
                            <label className="col-form-label" htmlFor="is_partner">
                            Is Partner:
                            </label>
                            {isReadOnly ? (
                              <>
                                <div className="form-control-plaintext">
                                    <input 
                                        type='text'
                                        className='form-control'
                                        readOnly
                                        value={formData.is_partner ? 'Yes' : 'No'}
                                        />
                                    {/* {formData.is_partner ? 'Yes' : 'No'} */}
                                </div>
                              </>
                            ) : (
                              <>
                                <select
                                    className="form-control"
                                    id="is_partner"
                                    name="is_partner"
                                    value={formData.is_partner}
                                    onChange={handlePartnerChange}
                                >
                                    <option value={false}>No</option>
                                    <option value={true}>Yes</option>
                                </select>
                              </>
                            )}
                    </div>
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-3">
                        {!isReadOnly && (
                        <button type="submit" className="btn btn-primary">
                            {mode === 'create' ? 'Create' : 'Submit'}
                        </button>
                        )}
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Close
                        </button>
                    </div>
                </form>
                </div>
            </div>
        </div>
    </div>
  );
};

export default MusicLabelForm;